import { IBaseAction } from '@/store/types/base.state';

export const sidebarActionTypes = {
  SET_SIDEBAR: 'SIDEBAR.SET_SIDEBAR',
} as const;

export interface ISetSidebarAction extends IBaseAction {
  type: typeof sidebarActionTypes.SET_SIDEBAR;
  isOpen: boolean;
}

export interface ISidebarState {
  isOpen?: boolean;
}
